import { render, staticRenderFns } from "./RemoveButtonTable.vue?vue&type=template&id=0a17e960&"
import script from "./RemoveButtonTable.vue?vue&type=script&lang=js&"
export * from "./RemoveButtonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports